var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.529 6.295c0-.237-.007-.471-.017-.705a11.064 11.064 0 002.707-2.818c-.974.433-2.018.725-3.115.858A5.467 5.467 0 0026.488.618a10.83 10.83 0 01-3.445 1.32 5.404 5.404 0 00-3.959-1.72c-2.994 0-5.423 2.438-5.423 5.445 0 .426.048.842.14 1.24C9.295 6.676 5.298 4.51 2.623 1.215a5.43 5.43 0 00-.735 2.738c0 1.887.958 3.554 2.414 4.53a5.383 5.383 0 01-2.457-.681v.07a5.44 5.44 0 004.35 5.336 5.424 5.424 0 01-2.45.095 5.43 5.43 0 005.068 3.779 10.855 10.855 0 01-6.737 2.33c-.438 0-.87-.025-1.294-.075a15.318 15.318 0 008.315 2.444c9.977 0 15.433-8.294 15.433-15.486z"
  })));
}

export default SvgTwitter;